import { Routes } from '@angular/router';
import { authGuard, publicGuard, unverifiedGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  // Public
  {
    path: '',
    loadComponent: () => import('./features/landing/landing').then((m) => m.Landing),
  },
  {
    path: 'login',
    canActivate: [publicGuard],
    loadComponent: () => import('./features/login/login').then((m) => m.Login),
  },
  {
    path: 'register',
    canActivate: [publicGuard],
    loadComponent: () => import('./features/register/register').then((m) => m.Register),
  },
  {
    path: 'forgot-password',
    canActivate: [publicGuard],
    loadComponent: () =>
      import('./features/forgot-password/forgot-password').then((m) => m.ForgotPassword),
  },
  {
    path: 'privacy',
    loadComponent: () => import('./features/privacy-info/privacy-info').then((m) => m.PrivacyInfo),
  },
  {
    path: 'terms',
    loadComponent: () => import('./features/terms-info/terms-info').then((m) => m.TermsInfo),
  },
  {
    path: 'account-deletion',
    loadComponent: () =>
      import('./features/account-deletion-info/account-deletion-info').then(
        (m) => m.AccountDeletionInfo,
      ),
  },
  {
    path: 'contact',
    loadComponent: () => import('./features/contact-form/contact-form').then((m) => m.ContactForm),
  },
  // Private
  {
    path: 'home',
    canActivate: [authGuard],
    loadComponent: () => import('./features/home/home').then((m) => m.Home),
  },
  {
    // Reached with a stored but unverified session; a verified one belongs in /home
    path: 'verify-email',
    canActivate: [unverifiedGuard],
    loadComponent: () => import('./features/verify-email/verify-email').then((m) => m.VerifyEmail),
  },

  // Fallback
  { path: '**', redirectTo: '' },
];
